import {Component} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserService} from "../../services/user.service";
import {SettingsService} from "../../services/settings.service";

@Component({
  selector: 'app-extend-session',
  templateUrl: './extend-session.component.html',
  styleUrls: ['./extend-session.component.scss']
})
export class ExtendSessionComponent {

  credentials: { username: string, password: string } = {username: '', password: ''};
  saveData: boolean = false;
  message: string = '';

  constructor(
      public userService: UserService,
      public modalService: NgbModal,
      private settings: SettingsService
  ) {
  }

  async extend() {
    if (this.credentials.username !== '' && this.credentials.password !== '') {
      try {
        await this.userService.extendToken(this.credentials);
        if (this.saveData) {
          await this.settings.set('credentials', this.credentials);
        }
        this.modalService.dismissAll();
      } catch (e: any) {
        if (e.error && e.error.error && e.error.error.details && e.error.error.details === 'Keine Rechte.') {
          this.message = 'Ihre Session konnte nicht verlängert werden. Überprüfen Sie Ihre Anmeldedaten.';
        } else {
          this.message = 'Ihre Session konnte nicht verlängert werden.';
        }
      }
    }
  }

}
